import React from 'react';

import { Box } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import LoadingAnimation from 'components/loading-animation';
import useEffectOnce from 'hooks/use-effect-once';
import { useCustomizableContent } from 'state/customizable-content';
import { getLocaleImage, getLocaleText, getLocaleTextBlock } from 'utils/sanity';

import { HeaderBlock } from './header-block';
import {
  Container,
  HeaderBlockContainer,
  Left,
  LoadingContainer,
  Outer,
  PictureContainer,
  Right,
  SideImage,
} from './onboarding-card.styled';

export const OnboardingCard = () => {
  const { formatMessage } = useIntl();

  const {
    loyaltyContent,
    requestLoyaltyCustomizableContent,
    isLoadingLoyalty,
  } = useCustomizableContent();
  useEffectOnce(requestLoyaltyCustomizableContent);

  const backgroundImage = getLocaleImage(loyaltyContent, 'onboardingContentCardBackgroundImage');
  const sideImage = getLocaleImage(loyaltyContent, 'onboardingImage');
  const headerBlockContent = getLocaleTextBlock(loyaltyContent, 'onboardingTextBlock');
  const buttonText = getLocaleText(loyaltyContent, 'onboardingButtonText');
  const buttonUrl = formatMessage({ id: 'routes.rewardsOnboarding' });
  return (
    <Outer>
      <PictureContainer image={backgroundImage.image} alt={backgroundImage.alt}>
        {isLoadingLoyalty ? (
          <LoadingContainer data-testid="onboarding-card-loading-container">
            <LoadingAnimation fillColor={Styles.color.white} />
          </LoadingContainer>
        ) : (
          <Container>
            <Left>
              {sideImage && sideImage.image && (
                <SideImage objectFitContain image={sideImage.image} alt={sideImage.alt || ''} />
              )}
            </Left>
            <Right>
              <HeaderBlockContainer>
                {headerBlockContent && <HeaderBlock content={headerBlockContent} />}
              </HeaderBlockContainer>
              {buttonText && (
                <Box margin="1.25rem 0 0.5rem">
                  <ActionButton variant={ActionButtonVariants.INVERSE} to={buttonUrl || '/'}>
                    {buttonText}
                  </ActionButton>
                </Box>
              )}
            </Right>
          </Container>
        )}
      </PictureContainer>
    </Outer>
  );
};

export default OnboardingCard;
